module.exports = __webpack_public_path__ + "eca46d2a6a3904d338962bfa92e4afd4.MP3";